import { createSlice } from "@reduxjs/toolkit";

const documentSlice = createSlice({
  name: "documentSlice",
  initialState: [],
  reducers: {
    addDocs: (state, action) => {
      const exists = state.some(
        (item) => item.docName === action.payload.docName
      );

      if (!exists) {
        state.push(action.payload);
      }
    },
    removeDocs: (state, action) => {
      const index = state.findIndex((item) => item._id === action.payload._id);

      if (index !== -1) {
        state.splice(index, 1); // removes 1 item at that index
      }
    },
    clearDocs: (state, action) => {
      state = [];
    },
  },
});

export const { addDocs, clearDocs, removeDocs } = documentSlice.actions;

export default documentSlice.reducer;
